import * as React from "react";
import { Button } from "../button";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "../dialog";

type ConfirmModalProps<T = any> = {
  open: boolean;
  title?: string;
  message?: string;
  data?: T;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  onOpenChange?: (open: boolean) => void;
  onConfirm: (data: T) => void;
  onCancel?: () => void;
  dialogContentProps?: React.ComponentProps<typeof DialogContent>;
};

export function ConfirmModal<T = any>({
  open,
  title = "Confirm",
  message = "Are you sure?",
  data,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  onOpenChange,
  onConfirm,
  onCancel,
  dialogContentProps,
}: ConfirmModalProps<T>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent {...dialogContentProps}>
        <DialogTitle>{title}</DialogTitle>
        <div className="my-4">{message}</div>
        <DialogFooter className="flex justify-end gap-2">
          <Button variant="secondary" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button onClick={() => onConfirm(data!)} disabled={loading}>
            {loading ? "Processing..." : confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
